import React from 'react';
import { Card, CardHead } from '../components/UI';
import s from './Fraud.module.css';

const ALERTS = [
  {
    type: 'critical',
    icon: 'ti-alert-circle',
    title: 'Duplicate bank account detected',
    sub: 'INV-1180 (IndoLub) — Bank A/C matches vendor "Axis Chemicals" (blocked). Possible shell entity.',
    tag: 'Critical',
  },
  {
    type: 'critical',
    icon: 'ti-alert-circle',
    title: 'Invoice value exceeds PO limit',
    sub: 'INV-1175 (Deccan Fuels) — Invoice ₹28.4 L vs PO ceiling ₹20 L. Unauthorised uplift of ₹8.4 L.',
    tag: 'High',
  },
  {
    type: 'warn',
    icon: 'ti-file-x',
    title: 'Missing mandatory NOC — payment blocked',
    sub: 'INV-1182 (Chennai Chemicals) — NOC required for chemical category. Supplier notified 02 Jul.',
    tag: 'Warning',
  },
  {
    type: 'info',
    icon: 'ti-info-circle',
    title: 'Policy deviation — unusual invoice timing',
    sub: 'INV-1176 (SunTech) — Invoice submitted 3 days after delivery window. Within policy tolerance, flagged for review.',
    tag: 'Info',
  },
];

const alertStyle = {
  critical: { bg:'#fef2f2', border:'#f8c6c6', iconColor:'var(--danger)', titleColor:'#b91c1c', tagBg:'#f8c6c6', tagColor:'#b91c1c' },
  warn:     { bg:'#fffbeb', border:'#f5dfa3', iconColor:'var(--warn)', titleColor:'#92600a', tagBg:'#f5dfa3', tagColor:'#92600a' },
  info:     { bg:'#dbeafe', border:'#bfdbfe', iconColor:'var(--info)', titleColor:'#1d4ed8', tagBg:'#bfdbfe', tagColor:'#1d4ed8' },
};

export default function Fraud() {
  return (
    <div>
      <div style={{marginBottom:12}}>
        {ALERTS.map((a, i) => {
          const st = alertStyle[a.type];
          return (
            <div key={i} className={s.fraudAlert} style={{background:st.bg, border:`1px solid ${st.border}`}}>
              <i className={`ti ${a.icon}`} style={{fontSize:18,color:st.iconColor,flexShrink:0}} />
              <div className={s.fatxt}>
                <div className={s.fatitle} style={{color:st.titleColor}}>{a.title}</div>
                <div className={s.fasub}>{a.sub}</div>
              </div>
              <span className={s.fatag} style={{background:st.tagBg,color:st.tagColor}}>{a.tag}</span>
            </div>
          );
        })}
      </div>

      <Card>
        <CardHead title="Fraud detection summary" />
        <div className={s.summGrid}>
          <div className={s.summBox}>
            <div style={{fontSize:22,fontWeight:700,color:'var(--danger)'}}>2</div>
            <div style={{fontSize:11,color:'var(--muted)',marginTop:2}}>Critical flags</div>
          </div>
          <div className={s.summBox}>
            <div style={{fontSize:22,fontWeight:700,color:'var(--warn)'}}>1</div>
            <div style={{fontSize:11,color:'var(--muted)',marginTop:2}}>Warnings</div>
          </div>
          <div className={s.summBox}>
            <div style={{fontSize:22,fontWeight:700,color:'var(--info)'}}>1</div>
            <div style={{fontSize:11,color:'var(--muted)',marginTop:2}}>Info alerts</div>
          </div>
        </div>
      </Card>
    </div>
  );
}
